import { string, object, bool, func, array } from 'prop-types'
import { Fragment } from 'react'
import { Asset } from '@opallabs/kuiper'
import { FileAsset } from '@opallabs/periodic/src/FileAsset'
import { AssetAndCopyHeader } from '../../AssetAndCopyHeader'
import { styles } from './styles'

export const Desktop = ({
  accountImage,
  accountName,
  assets,
  content,
  isPresenting,
  onContentChange,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
  updateCaption,
}) => (
  <Fragment>
    <AssetAndCopyHeader
      accountImage={accountImage}
      accountName={accountName}
      onContentChange={onContentChange}
      readOnly={readOnly}
      content={content}
      isPresenting={isPresenting}
    />
    {assets.length >= 0 &&
      assets.map((asset) => (
        <div key={asset.id} style={styles.previewWrapper}>
          {asset.asset_type === 'file' && asset.format !== 'pdf' ? (
            <div css={styles.fileWrapper}>
              <FileAsset
                asset={asset}
                onExpandAsset={onExpandAsset}
                onRemoveAsset={onRemoveAsset}
              />
            </div>
          ) : (
            <Asset
              imageFit="cover"
              hasAssetOptions={true}
              hasAssetOverlay={asset && (!readOnly || isPresenting)}
              assetReference={asset}
              placeholder={true}
              removeable={!isPresenting}
              updateCaption={updateCaption}
              overrideStyles={{ assetBase: styles.assets }}
              onEmbiggen={() => onExpandAsset(asset.id)}
              onRemove={() => onRemoveAsset(asset.id)}
            />
          )}
        </div>
      ))}
  </Fragment>
)

Desktop.propTypes = {
  accountImage: object,
  accountName: string,
  assets: array,
  content: string,
  isPresenting: bool,
  onAssetChange: func,
  onContentChange: func,
  onExpandAsset: func,
  onRemoveAsset: func,
  readOnly: bool,
  updateCaption: func,
}
